import '../../scripts/util/bootstrap-toolkit'

$(document).ready(function() {
  equalHeight('.js-col', '.js-title')
  equalHeight('.js-col', '.js-address')
})

function equalHeight(parentNode, node) {
  const currentBreakpoint = window.bootstrapToolkit.current()
  if (
    currentBreakpoint !== 'md' &&
    currentBreakpoint !== 'sm' &&
    currentBreakpoint !== 'xs'
  ) {
    $(parentNode).each(function() {
      let highestBox
      const elementNode = $(this)
        .closest('.row')
        .find(node)
      if ($(elementNode).length > 1) {
        highestBox = 0
      }
      $(elementNode).each(function() {
        if ($(this).outerHeight() > highestBox) {
          highestBox = $(this).outerHeight()
        }
      })
      $(elementNode).height(highestBox)
    })
  }
}
